









































































































import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";

import {
    notificationService,
    transportLoadService,
    transportVehicleService,
} from "@/services";

import {
    AuthenticationStatus,
    DateString,
    Notification,
    TransportLoad,
    TransportLoadTask,
    TransportVehicle,
} from "@/models";

import LoadTaskSelect from "../components/LoadTaskSelect.vue";
import TaskView from "../components/TaskView.vue";
import TransitionView from "../components/TransitionView.vue";
import VehicleCalendar from "../components/VehicleCalendar.vue";
import VehicleSelectDialog from "../components/VehicleSelectDialog.vue";

@Component({
    components: {
        LoadTaskSelect,
        TaskView,
        TransitionView,
        VehicleCalendar,
        VehicleSelectDialog
    }
})
export default class App extends Vue {
    @Prop() authentication!: AuthenticationStatus;

    get hasTaskPlan(): boolean {
        return this.authentication.roles.indexOf("Sulo.KKTaskPlan") !== -1;
    }

    get favoriteVehiclesOnly() {
        return this.authentication.roles.indexOf("Sulo.KKTaskPlan") !== -1 ||
            this.authentication.roles.indexOf("Sulo.KKViewer") !== -1 ||
            this.authentication.roles.indexOf("Sulo.KKContainer") !== -1;
    }

    notifications: Notification[] = [];

    vehicle: null | TransportVehicle = null;
    vehicleDialog = true;

    date: DateString = new Date().toISOString().split("T")[0];
    dateModal = false;

    skipLaunchOldLoadCheck = false;

    get dateDisplay() {
        if (!this.date) {
            return "";
        }

        const date = new Date(this.date);
        return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
    }

    loads: null | TransportLoad[] = null;
    selection: null | { load: TransportLoad; loadTask: TransportLoadTask } = null;

    oldTasksNotice = false;

    async mounted() {
        this.skipLaunchOldLoadCheck = !!this.$route.query.loadTaskId;

        this.loadNotifications();

        this.vehicleIdChanged();
        this.dateChanged();

        this.$watch("vehicle", () => { this.updateLoads(); });
        this.$watch("date", () => { this.updateLoads(); });

        this.$watch("$route.query.loadTaskId", () => { this.resolveSelection(); });
        this.$watch("loads", () => { this.resolveSelection(); });
    }

    async loadNotifications() {
        let notifications = await notificationService.listMyNotifications("Mobisulo");

        try {
            const closedIds: number[] = JSON.parse(localStorage.getItem("mobisulo.closednotifications") as string);

            notifications = notifications.filter(n => !closedIds.find(id => id === n.notificationId));
        } catch {
            // Ignore
        }

        this.notifications = notifications;
    }

    closeNotification(notificationId: number) {
        let closedIds: number[] | null = null;

        try {
            closedIds = JSON.parse(localStorage.getItem("mobisulo.closednotifications") as string);
        } catch {
            // Ignore
        }

        if (!closedIds) {
            closedIds = [];
        }

        closedIds.push(notificationId);

        localStorage.setItem("mobisulo.closednotifications", JSON.stringify(closedIds));
    }

    @Watch("$route.query.vehicleId")
    async vehicleIdChanged() {
        const vehicleId = this.$route.query.vehicleId as string;

        if (this.vehicle && this.vehicle.vehicleId === vehicleId) {
            return;
        }

        this.vehicle = null;

        if (vehicleId) {
            this.vehicleDialog = false;

            // TODO cancel
            this.vehicle = await transportVehicleService.getVehicle(vehicleId);
            if (!this.vehicle) {
                this.setVehicle(null);
            }
        }
    }

    @Watch("$route.query.date")
    dateChanged() {
        const date = this.$route.query.date as string;
        if (date === this.date) {
            return;
        }

        if (!date || isNaN(Date.parse(date))) {
            this.setDate(new Date().toISOString().split("T")[0]);
        } else {
            this.setDate(date);
        }
    }

    setVehicle(vehicle: null | TransportVehicle) {
        const vehicleId = (vehicle != null ? vehicle.vehicleId : null) || "";

        this.vehicle = vehicle;
        this.vehicleDialog = !this.vehicle;

        if (vehicleId !== this.$route.query.vehicleId as string) {
            const query = Object.assign({}, this.$route.query);
            query.vehicleId = vehicleId;

            this.$router.push({
                query
            });
        }
    }

    setDate(date: null | string) {
        date = date || "";

        this.date = date;
        this.dateModal = !date;

        if (date !== this.$route.query.date as string) {
            const query = Object.assign({}, this.$route.query);
            query.date = date || "";

            this.$router.push({
                query
            });
        }
    }

    @Watch("vehicle")
    async findOldestIncompleteLoad(vehicle: null | TransportVehicle) {
        if (!vehicle) {
            return;
        }

        if (this.skipLaunchOldLoadCheck) {
            this.skipLaunchOldLoadCheck = false;
            return;
        }

        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const monthAgo = new Date();
        monthAgo.setMonth(yesterday.getMonth() - 1);

        // TODO cancel
        const loads = await transportLoadService.searchLoads({
            targetDateMin: monthAgo.toISOString(),
            targetDateMax: yesterday.toISOString(),
            vehicleId: [ vehicle.vehicleId ],
            loadState: [ "New" ]
        }, 0, 1);

        if (loads.items.length) {
            this.setDate(loads.items[0].targetDate.split("T")[0]);
            this.oldTasksNotice = true;
            return;
        }
    }

    async updateLoads() {
        // // TODO cancel
        this.loads = null;

        if (!this.vehicle || !this.date) {
            return;
        }

        this.loads = (
            await transportLoadService.searchLoads({
                vehicleId: [this.vehicle.vehicleId],
                targetDate: this.date
            })
        ).items;
    }

    resolveSelection() {
        if (!this.loads) {
            return;
        }

        const loadTaskId = this.$route.query.loadTaskId as string;
        if (!loadTaskId) {
            this.selection = null;
            return;
        }

        const load = this.loads.find(l => l.loadTasks.find(lt => lt.loadTaskId === loadTaskId));
        const loadTask = load ? load.loadTasks.find(lt => lt.loadTaskId === loadTaskId) : null;

        if (load && loadTask) {
            this.selection = { load, loadTask };
        } else {
            this.setSelection(null);
        }
    }

    setSelection(selection: null | { load: TransportLoad; loadTask: TransportLoadTask }) {
        const query = Object.assign({}, this.$route.query);
        query.loadTaskId = (selection != null ? selection.loadTask.loadTaskId : null) || "";

        this.$router.push({
            query
        });

        this.selection = selection;
    }

    async reload() {
        await this.updateLoads();
    }
}
